import { useState } from 'react';
import { cn } from '@shared/utils';
import { Card, type TariffJsonResponse } from '@shared/api';
import ArrowIcon from '@assets/images/arrow_mobile.svg';

const getCard = (type: Card) => {
  switch (type) {
    case Card.Elite:
      return (
        <span>
          {type} <span className='normal-case'>(Supplementary only)</span>
        </span>
      );
    default:
      return type;
  }
};

interface TariffTableProps {
  className?: string;
  tariffs: TariffJsonResponse;
}

export const TariffList = (props: TariffTableProps) => {
  const [opened, setOpened] = useState<string>('');

  const setOpenedItem = (l1: string) => setOpened(l1 == opened ? '' : l1);

  const isOpened = (l1: string) => {
    if (l1 === '') return false;
    if (l1 !== opened) return false;
    return true;
  };

  return (
    <div className={cn('px-4 text-[13px]', props.className)}>
      {props.tariffs.cards.map((card, idx) => (
        <div key={idx} className='border-b border-b-[#4c4c4c1a]'>
          <div className='relative flex justify-between py-4 font-bold uppercase' onClick={() => setOpenedItem(card.card)}>
            {getCard(card.card)}
            <ArrowIcon className={cn(isOpened(card.card) && 'rotate-90')} />
          </div>
          <div className={cn('hidden', isOpened(card.card) && 'block')}>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Currencies</div>
              <div>{card.currencies}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Card Type</div>
              <div>{card.cardType}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Jewellery Card Production Cost</div>
              <div>{card.jewelleryCardProductionCost}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Annual Fee</div>
              <div>{card.annualFee}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Dual Annual Fee</div>
              <div>{card.dualAnnualFee}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Supplementary Cards</div>
              <div>{card.supplementaryCards}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Card Replacement Fee</div>
              <div>{card.cardReplacementFee}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>PIN Change Fee</div>
              <div>{card.pinChangeFee}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Printed Statement Fee</div>
              <div>{card.printedStatementFee}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Insignia Online Network</div>
              <div>{card.insigniaOnlineNetwork}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Emergency Card Delivery Fee</div>
              <div>{card.emergencyCardDeliveryFee}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Late Payment Fee</div>
              <div>{card.latePaymentFee}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Late Payment Interest</div>
              <div>{card.latePaymentInterest}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Exchange Rate Conversion Fee</div>
              <div>{card.exchangeRateConversionFee}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Original Credit Transaction</div>
              <div>{card.originalCreditTransaction}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Quarterly Administrative Fee</div>
              <div>{card.quarterlyAdministrativeFee}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Administrative Investigation Fee</div>
              <div>{card.administrativeInvestigationFee}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>VISA Arbitration Fee</div>
              <div>{card.visaArbitrationFee}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Daily Spending Limit</div>
              <div>{card.dailySpendingLimit}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>ATM Withdrawal Fee</div>
              <div>{card.atmWithdrawalFee}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Cash-desk Withdrawal Fee</div>
              <div>{card.cashDeskWithdrawalFee}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Limit per Billing Cycle</div>
              <div>{card.limitPerBillingCycle}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Billing Cycle</div>
              <div>{card.billingCycle}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Minimum Upload</div>
              <div>{card.minimumUpload}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Transfer Fee In / Upload</div>
              <div>{card.transferFeeInUpload}</div>
            </div>
            <div className='flex min-h-12 items-center justify-between gap-4 py-2'>
              <div className='w-1/2 flex-none text-[#4c4c4c80]'>Transfer Fee Out</div>
              <div>{card.transferFeeOut}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
